// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ResolverGroup from "./resolverGroup";
import {
  getLocationData,
  getGroups
} from "./resolverGroupRedux/resolverGroupActionCreator";
import ComponentWithSideMenu from "../../../commons/componentWithSideMenu/componentWithSideMenu";
import Loader from "../../../commons/loader/loader";
import { setPageName } from "../../../../services/pageService/pageActionCreator";

type Props = {
  getLocationData: Function,
  getGroups: Function,
  resolverGroupState: Object,
  setPageName: Function
};

type State = {
  selectedGroup: Object,
  locationCode: string,
  locationId: Integer
};

const pageObj = {
  pageName: "Resolver Group Settings"
};

class ResolverGroupParent extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      selectedGroup: null,
      locationCode: "HQTR",
      locationId: 9,
      locationOptions: [],
      createPage: false
    };
    this.updateSelectedGroupAfterSubmit = this.updateSelectedGroupAfterSubmit.bind(
      this
    );
  }

  componentDidMount() {
    this.props.getLocationData();
    this.props.setPageName(pageObj);
    this.getGroupsByLocation("HQTR");
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.props.resolverGroupState.locationData.isLoaded &&
      nextProps.resolverGroupState.locationData.isLoaded
    ) {
      this.setGroupLocationOptions(
        nextProps.resolverGroupState.locationData.data
      );
    } else if (
      nextProps.resolverGroupState.group &&
      nextProps.resolverGroupState.group.data &&
      this.props.resolverGroupState.group !== nextProps.resolverGroupState.group
    ) {
      this.getGroupsByLocation(this.state.locationCode, () => {
        this.updateSelectedGroupAfterSubmit(nextProps.resolverGroupState.group);
      });
    }
  }

  onBackPressed() {
    this.setState({
      selectedGroup: null,
      createPage: false
    });
  }

  setGroupLocationOptions(locationData) {
    const options = [];
    locationData.forEach(option => {
      if (option.isActive) {
        options.push({
          key: option.code,
          val: option.code,
          id: option.id
        });
      }
    });
    this.setState({ locationOptions: options });
  }

  getGroupsByLocation(locationCode, cb = () => {}) {
    if (locationCode && locationCode !== "") {
      this.props.getGroups(locationCode, cb);
    }
  }

  getSelectedGroup(data) {
    if (this.state.selectedGroup) {
      return this.state.selectedGroup;
    }
    if (data && data.length) {
      return data[0];
    }
    return null;
  }

  updateSelectedGroupAfterSubmit(newGroup) {
    const newSelectedGroup = (
      (this.props.resolverGroupState.groupData &&
        this.props.resolverGroupState.groupData.data &&
        this.props.resolverGroupState.groupData.data.groups) ||
      []
    ).filter(group => group.id === newGroup.data.id)[0];
    this.setState({
      selectedGroup: newSelectedGroup,
      createPage: false
    });
  }

  changeLocation(val, event) {
    this.setState(
      {
        locationCode: val,
        locationId: event.id,
        selectedGroup: null,
        createPage: false
      },
      () => {
        this.getGroupsByLocation(this.state.locationCode);
      }
    );
  }

  selectOption(value) {
    this.setState({
      selectedGroup: value,
      createPage: false
    });
  }

  renderResolverGroupForm(group, members, escalationMap, memberUserIds) {
    return (
      <div>
        <ResolverGroup
          location={{
            locationCode: this.state.locationCode,
            locationId: this.state.locationId
          }}
          group={this.state.createPage ? null : group}
          members={this.state.locationCode === "HQTR" ? [] : members}
          escalationMap={
            this.state.locationCode === "HQTR" ? {} : escalationMap
          }
          memberUserIds={
            this.state.locationCode === "HQTR" ? [] : memberUserIds
          }
          onBack={() => this.onBackPressed()}
        />
      </div>
    );
  }

  renderCreateRenderPage() {
    this.setState({
      selectedGroup: null,
      createPage: true
    });
  }

  render() {
    const { locationData } = this.props.resolverGroupState;
    const { groupData } = this.props.resolverGroupState || {};
    const { groups } = (groupData && groupData.data) || {};
    const { members, memberUserIds, escalationMap } =
      (groupData && groupData.data && groupData.data.resolverGroupDto) || {};

    if (!locationData.isLoaded) {
      return <Loader />;
    }
    return (
      <div>
        <ComponentWithSideMenu
          menuOptions={groups || []}
          selectOption={option => this.selectOption(option)}
          topSelectOptions={this.state.locationOptions}
          onTopSelectChange={(val, event) => this.changeLocation(val, event)}
          topOption="+ Create Resolver Group"
          selectTopOption={() => this.renderCreateRenderPage()}
          topSelectDefaultValue="HQTR"
        >
          {groupData.isLoaded ? (
            this.renderResolverGroupForm(
              this.getSelectedGroup(groups),
              members,
              escalationMap,
              memberUserIds
            )
          ) : (
            <Loader />
          )}
        </ComponentWithSideMenu>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  resolverGroupState: state.resolverGroupState
});

const mapDispatchToProps = dispatch => ({
  getLocationData: bindActionCreators(getLocationData, dispatch),
  getGroups: bindActionCreators(getGroups, dispatch),
  setPageName: bindActionCreators(setPageName, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResolverGroupParent);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/resolverGroup/resolverGroupParent.js